import { render, staticRenderFns } from "./GSelect.vue?vue&type=template&id=fff0d324"
import script from "./GSelect.vue?vue&type=script&lang=js"
export * from "./GSelect.vue?vue&type=script&lang=js"
import style0 from "./GSelect.vue?vue&type=style&index=0&id=fff0d324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports